<template>
  <div class="image-property">
    <svg-icon :icon="icon" :title="label" />
    <span class="label" v-if="!noText"> {{ label }}</span>
    <span class="value">{{ value }}</span>
  </div>
</template>

<script setup lang="ts">
import SvgIcon from '@/components/SvgIcon.vue'

defineProps<{
  label: string
  icon: string
  value: string
  noText?: boolean
}>()
</script>

<style lang="scss">
@import 'src/main.scss';

.image-property {
  display: inline-block;
  margin: 4px 8px;
  font-size: 13px;
  white-space: nowrap;

  .label {
    font-size: 10px;
    font-weight: bold;
    display: inline;
    margin-left: 4px;
  }

  .svg-icon {
    font-size: 16px;
  }

  .value {
    display: inline-block;
    margin-left: 4px;
  }
}
</style>
